import { render, staticRenderFns } from "./messageForm.vue?vue&type=template&id=3b5ef500&scoped=true"
import script from "./messageForm.vue?vue&type=script&lang=js"
export * from "./messageForm.vue?vue&type=script&lang=js"
import style0 from "./messageForm.vue?vue&type=style&index=0&id=3b5ef500&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5ef500",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b5ef500')) {
      api.createRecord('3b5ef500', component.options)
    } else {
      api.reload('3b5ef500', component.options)
    }
    module.hot.accept("./messageForm.vue?vue&type=template&id=3b5ef500&scoped=true", function () {
      api.rerender('3b5ef500', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notify/systemScene/components/messageForm.vue"
export default component.exports